export default {
    'editor': {
        'heading_1': 'Naslov 1',
        'heading_2': 'Naslov 2',
        'heading_3': 'Naslov 3',
        'paragraph': 'Odstavek',
        'bold': 'Krepko',
        'italic': 'Ležeče',
        'underline': 'Podčrtano',
        'ordered_list': 'Oštevilčen seznam',
        'bullet_list': 'Označen seznam',
        'align_left': 'Poravnaj levo',
        'align_center': 'Poravnaj na sredino',
        'align_right': 'Poravnaj desno',
        'align_justify': 'Obojestransko',
        'link': 'Povezava',
        'color': 'Barva besedila',
        'image': 'Slika',
        'divider': 'Ločnica'
    },
    'colors': {
        'red': 'Rdeča',
        'orange': 'Oranžna',
        'yellow': 'Rumena',
        'green': 'Zelena',
        'blue': 'Modra',
        'purple': 'Vijolična',
        'pink': 'Roza',
        'gray': 'Siva'
    },
    'general': {
        'administration': 'Administracija',
        'dashboard': 'Nadzorna plošča',
        'email': 'E-pošta',
        'phone': 'Telefon',
        'username': 'Uporabniško ime',
        'name': 'Ime',
        'password': 'Geslo',
        'value': 'Vrednost',
        'actions': 'Dejanja',
        'login': 'Prijava',
        'logout': 'Odjava',
        'no_results': 'Ni rezultatov',
        'success': 'Uspešno',
        'warning': 'Opozorilo',
        'remember_me': 'Zapomni si me',
        'error': 'Napaka',
        'edit': 'Uredi',
        'details': 'Podrobnosti',
        'add': 'Dodaj',
        'delete': 'Izbriši',
        'yes': 'Da',
        'no': 'Ne',
        'cancel': 'Prekliči',
        'back': 'Nazaj',
        'image': 'Slika',
        'filters': 'Filtri',
        'remove_filters': 'Odstrani filtre',
        'default': 'Privzeto',
        'save': 'Shrani',
        'preview': 'Predogled',
        'icon': 'Ikona',
        'change': 'Spremeni',
        'unlimited': 'Neomejeno',
        'active': 'Aktivno',
        'all': 'Vse',
        'from': 'Od',
        'to': 'Do',
        'date': 'Datum',
        'custom': 'Po meri',
        'country': 'Država',
        'total': 'Skupaj',
        'basic_data': 'Osnovni podatki',
        'show_more': 'Prikaži več',
        'export_data': 'Izvozi podatke',
        'approve': 'Odobri',
        'reject': 'Prekliči',
        'generate': 'Generiraj',
        'check': 'Preveri',
        'file_type': 'Tip datoteke',
        'size': 'Velikost',
        'text': 'Besedilo',
        'title': 'Naslov',
        'address': 'Naslov',
        'zip': 'Poštna številka',
        'city': 'Mesto',
        'created': 'Ustvarjeno',
        'drag_and_drop_files_to_upload': 'Povlecite in spustite datoteke za nalaganje',
        'file_missing': 'Datoteka ne obstaja',
        'upload_failed': 'Nalaganje ni uspelo',
        'retry_upload': 'Poskusi znova',
        'delete_all': 'Izbriši vse',
        'left': 'Levo',
        'right': 'Desno',
        'top': 'Zgoraj',
        'bottom': 'Spodaj',
        'settings': 'Nastavitve',
        'instructions': 'Navodila',
        'instructions_admin_portal': 'Navodila za administracijski portal',
        'instructions_website_images': 'Navodila za slike na spletni strani',
        'open': 'Odpri',
        'download': 'Prenesi',
        'guarantee_specification': 'Specifikacija garancije'
    },
    'errors': {
        'generic_error': 'Prišlo je do napake',
        'login': 'Prišlo je do napake pri prijavi',
        'logout': 'Prišlo je do napake pri odjavi',
        'incorrect_password': 'Staro geslo ni pravilno',
        'invalid_data': 'Prejeti neveljavni podatki',
        'not_found': 'Podatki niso najdeni',
        'user_exist': 'Uporabnik s tem e-poštnim naslovom že obstaja',
        'load_data': 'Prišlo je do napake pri nalaganju podatkov',
        'on_upload_file': 'Prišlo je do napake pri nalaganju datotek',
        'on_export_file': 'Prišlo je do napake pri izvozu datoteke',
        'on_import_file': 'Prišlo je do napake pri uvozu datoteke',
        'on_add': 'Prišlo je do napake pri dodajanju',
        'on_edit': 'Prišlo je do napake pri urejanju',
        'on_delete': 'Prišlo je do napake pri brisanju',
        'on_sort': 'Prišlo je do napake pri razvrščanju',
        'unauthorized': 'Nepooblaščen dostop',
        'user_does_not_exist': 'Uporabnik ne obstaja',
        'failed_to_insert': 'Vstavljanje ni uspelo',
        'file_to_big': 'Datoteka je prevelika',
        'file_type_not_allowed': 'Vrsta datoteke ni dovoljena',
        'unable_to_retrieve_extension': 'Ne morem pridobiti končnice',
        'no_access': 'Ni dostopa',
        'field_name_exists': 'Ime polja že obstaja',
        'category_exists': 'Kategorija z enim od vnesenih imen že obstaja',
        'product_brand_exists': 'Blagovna znamka z vnesenim imenom že obstaja',
        'sale_partner_exists': 'Partner za prodajo z vnesenim imenom že obstaja',
        'additional_page_exists': 'Dodatna stran z vnesenim imenom že obstaja',
        'invalid_order_status': 'Neveljaven status naročila',
        'product_exists': 'Izdelek s SKU in državo že obstaja',
        'product_slug_exists': 'Izdelek z enakim imenom za SKU in državo že obstaja',
        'unknown_type': 'Neznana vrsta',
        'price_list_for_selected_partner_is_empty': 'Cenik za izbranega partnerja je prazen',
        'product_title_required': 'Naziv izdelka je obvezen',
        'product_country_required': 'Država izdelka je obvezna',
        'product_vat_group_required': 'DDV skupina izdelka je obvezna',
        'product_price_invalid': 'Cena izdelka ne sme biti negativna',
        'product_discount_invalid': 'Popust izdelka mora biti med 0 in 100',
        'product_stock_invalid': 'Zaloga izdelka ne sme biti negativna',
        'vat_group_not_found_for_country': 'DDV skupina ne obstaja za izbrano državo',
        'category_not_found': 'Kategorija ne obstaja',
        'sale_website_not_found': 'Prodajna stran ne obstaja',
        'product_brand_not_found': 'Blagovna znamka ne obstaja',
        'specification_not_found': 'Specifikacija izdelka ne obstaja',
        'invalid_field_value': 'Neveljavna vrednost v polju',
        'sale_website_type_exists': 'Spletna stran z izbrano vrsto strani že obstaja',
        'discount_coupon_code_invalid': 'Koda mora imeti od 3 do 50 znakov: A-Z, 0-9, - in _',
        'discount_coupon_invalid_type': 'Neznan tip popusta',
        'discount_coupon_value_invalid': 'Vrednost popusta mora biti med 0 in 100',
        'discount_coupon_validity_invalid': 'Datum »velja od« mora biti pred datumom »velja do«',
        'discount_coupon_code_exists': 'Koda za popust s to kodo že obstaja',
        'discount_coupon_country_invalid': 'Neveljavna država na kodi za popust',
        'product_warranty_invalid': 'Garancija ne sme biti negativna in mora imeti enoto'
    },
    'success': {
        'on_add': 'Uspešno dodano',
        'on_edit': 'Uspešno urejeno',
        'on_delete': 'Uspešno izbrisano',
        'on_sort': 'Uspešno razvrščeno'
    },
    'confirmations': {
        'general': 'Ste prepričani, da želite nadaljevati?',
        'header': 'Ste prepričani',
        'delete_row': 'Ste prepričani, da želite izbrisati',
        'delete_all': 'Ste prepričani, da želite izbrisati vse?',
        'unsaved_changes': 'Neshranjene spremembe',
        'unsaved_changes_info': 'Ali ste prepričani, da želite zapustiti to stran? Vse vaše spremembe bodo izgubljene.',
        'disable_product': 'Ali res želite onemogočiti izdelek {title}? Izdelek bo odstranjen s spletnih strani, cenikov in iskalnika.',
        'enable_product': 'Ali res želite ponovno omogočiti izdelek {title}? Izdelek bo dobil status Ni objavljeno.'
    },
    'table': {
        'no_data': 'Ni podatkov za prikaz',
        'press_enter_search': 'Pritisnite enter za iskanje',
        'search': 'Iskanje po',
        'select_option': 'Izberite možnost',
        'select_date': 'Izberite datum',
        'select_range': 'Izberite obseg',
        'of': 'od'
    },
    'profile': {
        'profile': 'Profil',
        'edit_profile': 'Uredi profil',
        'old_password': 'Staro geslo',
        'new_password': 'Novo geslo',
        'confirm_password': 'Potrdi geslo',
        'change_password': 'Spremeni geslo'
    },
    'language': {
        'slovenian': 'Slovenščina',
        'english': 'Angleščina',
        'croatian': 'Hrvaščina'
    },
    'country_sale': {
        'slovenia': 'Slovenija',
        'croatia': 'Hrvaška',
        'serbia': 'Srbija',
        'austria': 'Avstrija'
    },
    'user': {
        'user': 'Uporabnik | Uporabniki',
        'add': 'Dodaj uporabnika',
        'edit': 'Uredi uporabnika',
        'firstname': 'Ime',
        'lastname': 'Priimek',
        'email': 'E-pošta',
        'language': 'Jezik',
        'password': 'Geslo',
        'cannot_edit_email': 'E-pošte ni mogoče urediti'
    },
    'vat_group': {
        'vat_group': 'Davčna stopnja | Davčne stopnje',
        'add': 'Dodaj davčno stopnjo',
        'edit': 'Uredi davčno stopnjo',
        'country': 'Država',
        'prices_not_recalculated': 'Sprememba davčne stopnje ne spremeni cen izdelkov, ki to davčno stopnjo uporabljajo. Cene je treba po potrebi popraviti ročno.'
    },
    'discount_coupon': {
        'discount_coupon': 'Koda za popust | Kode za popust',
        'add': 'Dodaj kodo za popust',
        'edit': 'Uredi kodo za popust',
        'code': 'Koda',
        'type': 'Tip popusta',
        'type_percentage': 'Odstotek',
        'valid_from': 'Velja od',
        'valid_to': 'Velja do',
        'validity': 'Veljavnost',
        'validity_hint': 'Prazen datum pomeni brez omejitve.',
        'scope': 'Kje velja',
        'scope_hint': 'Prazen seznam pomeni brez omejitve. Vsak izpolnjen seznam je pogoj: izdelek mora ustrezati hkrati izbrani kategoriji, blagovni znamki in izdelku. Znotraj posameznega seznama zadošča katerakoli izbira.',
        'selected_products': 'Izbrani izdelki',
        'select_products': 'Izberi izdelke',
        'no_selected_products': 'Ni izbranih izdelkov',
        'generate_code': 'Generiraj kodo',
        'applied_to_item': 'Za to postavko je bila uporabljena koda za popust',
        'countries': 'Države',
        'countries_hint': 'Na voljo so države izbranih spletnih strani.'
    },
    'product_specification': {
        'product_specification': 'Specifikacija produkta | Specifikacije produkta',
        'add': 'Dodaj specifikacijo produkta',
        'edit': 'Uredi specifikacijo produkta',
        'field_name': 'Ime polja',
        'field_name_info': 'Priporočljivo je, da se ime polja zapiše v angleškem jeziku. Primeri: load_capacity, height, weight.',
        'field_name_exists': 'Ime polja že obstaja',
        'required_specification': 'Obvezna specifikacija',
        'predefined_values': 'Vnaprej določene vrednosti',
        'value': 'Vrednost',
        'add_new_value': 'Dodaj novo vrednost',
        'position': 'Pozicija'
    },
    'required_category_specification': {
        'required_category_specification': 'Zahtevana specifikacija kategorije | Zahtevane specifikacije kategorij',
        'add': 'Dodaj zahtevane specifikacije kategorije',
        'edit': 'Uredi zahtevane specifikacije kategorije'
    },
    'sale_website': {
        'sale_website': 'Spletna stran | Spletne strani',
        'add': 'Dodaj spletno stran',
        'edit': 'Uredi spletno stran',
        'type': 'Vrsta strani',
        'countries': 'Države',
        'color': 'Barva',
        'button_text': 'Besedilo gumba',
        'button_type': 'Vrsta gumba',
        'link': 'Povezava',
        'button': 'Gumb | Gumbi',
        'no_buttons_defined': ' Ni definiranih gumbov',
        'image_position': 'Pozicija slike',
        'image_on_right': 'Slika na desni',
        'full_width_image': 'Slika v polni širini',
        'show_background': 'Prikaži ozadje',
        'show_as_slider': 'Prikaži kot slider',
        'is_video': 'Je video',
        'general_info': 'Generalne informacije',
        'home_page': 'Domača stran',
        'save_home_page': 'Shrani domačo stran',
        'additional_product_pages': 'Dodatne strani z izdelki',
        'primary_specification_filters': 'Primarni filtri specifikacij',
        'service': 'Servis',
        'about_us': 'O nas',
        'terms_and_conditions': 'Pogoji poslovanja',
        'privacy_policy': 'Politika zasebnosti',
        'company_presentation': 'Predstavitev podjetja',
        'custom_solutions': 'Rešitve po meri',
        'representation': 'Zastopstvo',
        'customer_support': 'Podpora strankam',
        'delivery': 'Dostava',
        'payment_methods': 'Načini plačila',
        'top_nav_banner': 'Zgornji navigacijski pasica',
        'social_media': 'Socialni mediji',
        'service_information': 'Informacije o servisu',
        'contact': 'Kontakt',
        'active': 'Aktivno',
        'show_in_top_navigation': 'Prikaži v navigaciji na vrhu',
        'show_in_bottom_navigation': 'Prikaži v navigaciji na dnu',
        'page': 'Stran',
        'internal_page': 'Interna stran',
        'external': 'Zunanja povezava',
        'download_attachment': 'Prenos datoteke',
        'add_to_cart': 'Dodaj v košarico',
        'component': 'Kompoenta | Komponente',
        'configuration': 'Konfiguracija',
        'select_custom': 'Izberi po meri',
        'content': 'Vsebina',
        'invalid_page_content_button_values': 'Izbrane vrednosti na straneh, ki vsebujejo gumbe so nepravilne. Preverite vse komponente z gumbi.',
        'invalid_buttons': 'Gumbi, ki ne vodijo nikamor',
        'invalid_buttons_info': 'Ti gumbi kažejo na izdelek ali stran, ki ne obstaja več. Odprite mesto, kjer je gumb shranjen, in ga popravite ali odstranite.',
        'invalid_button_place': 'Mesto',
        'invalid_button_reason_header': 'Razlog',
        'invalid_button_component_position': 'komponenta {index}',
        'invalid_button_item_position': 'element {index}',
        'invalid_button_button_position': 'gumb {index}',
        'invalid_button_location': {
            'top_nav_banner': 'Pasica v zgornji navigaciji',
            'home_page': 'Domača stran',
            'additional_page': 'Dodatna stran'
        },
        'invalid_button_reason': {
            'product_not_found': 'Izdelek s to povezavo ne obstaja',
            'additional_page_not_found': 'Dodatna stran s to povezavo ne obstaja',
            'component_data_unreadable': 'Podatkov komponente ni mogoče prebrati'
        },
        'no_components': 'Ta stran še ne vsebuje komponent',
        'no_components_info': 'Komponento dodate s klikom na eno od vrst v seznamu.',
        'email_to_which_notifications_will_be_sent': 'Email na katerega bodo poslana obvestila',
        'checkout_methods': 'Načini plačila in dostave',
        'checkout_methods_info': 'Stranki se ponudijo samo aktivni načini z imenom, v vrstnem redu, ki je nastavljen tukaj. Način brez imena se ne shrani.',
        'shipping_methods': 'Načini dostave',
        'shipping_price': 'Cena',
        'shipping_price_info': 'Cena se obračuna, ko je košarica težja od vseh spodnjih omejitev teže.',
        'max_weight': 'Do teže',
        'add_weight_price': 'Dodaj ceno po teži',
        'payment_method_type': {
            'credit_card': 'Plačilo s kartico',
            'bank_transfer': 'Plačilo po predračunu',
            'cash_on_delivery': 'Plačilo po povzetju'
        },
        'shipping_method_type': {
            'local_pickup': 'Osebni prevzem',
            'slovenian_post': 'Pošta Slovenije',
            'intereuropa': 'Intereuropa'
        },
        'component_type': {
            'image_slider': 'Drsnik slik',
            'item_slider': 'Drsnik elementov',
            'gallery': 'Galerija',
            'hero': 'Hero',
            'specification': 'Specifikacije',
            'banner': 'Baner',
            'text_content': 'Besedilo',
            'partner_slider': 'Drsnik partnerjev',
            'card_slider': 'Drsnik kartic',
            'showcase_items': 'Izpostavljene kartice',
            'newsletter_subscription': 'Prijava no novice',
            'contact_form': 'Kontaktni obrazec',
            'button': 'Gumb'
        }
    },
    'product_brand': {
        'product_brand': 'Blagovna znamka | Blagovne znamke',
        'add': 'Dodaj blagovno znamko',
        'edit': 'Uredi blagovno znamko',
        'importer': 'Uvoznik | Uvozniki',
        'add_importer': 'Dodaj uvoznika',
        'edit_importer': 'Uredi uvoznika',
        'service': 'Servis | Servisi',
        'add_service': 'Dodaj servis',
        'edit_service': 'Uredi servis',
        'disclaimer': 'Omejitev odgovornosti | Omejitve odgovornosti',
        'add_disclaimer': 'Dodaj omejitev odgovornosti',
        'warranty_hint': 'Velja za vse izdelke te blagovne znamke, ki nimajo svoje garancije.',
        'edit_disclaimer': 'Uredi omejitev odgovornosti',
        'website': 'Spletna stran'
    },
    'category': {
        'category': 'Kategorija | Kategorije',
        'add_new': 'Dodaj novo',
        'delete_info': 'To bo izbrisalo tudi vse podkategorije!',
        'not_all_fields_filled_info': 'Niso izpolnjena vsa polja',
        'search': 'Išči po kategorijah',
        'ignored_categories_on_user_page': 'Ignorirane kategorije na uporabniški strani',
        'choose_your_source_category': 'Izberi svojo izvorno kategorijo'
    },
    'product': {
        'product': 'Izdelek | Izdelki',
        'synced_product': 'Sinhroniziran izdelek | Sinhronizirani izdelki',
        'add': 'Dodaj izdelek',
        'edit': 'Uredi izdelek',
        'id': 'ID izdelka',
        'sku': 'SKU',
        'ean': 'EAN',
        'stock': 'Zaloga',
        'title': 'Naziv',
        'pretext': 'Predbesedilo',
        'description': 'Opis',
        'short_description': 'Kratek opis',
        'price': 'Cena',
        'regular_price': 'Redna cena',
        'price_without_vat': 'Cena brez DDV',
        'price_with_vat': 'Cena z DDV',
        'discount': 'Popust',
        'main_image': 'Glavna slika',
        'additional_images': 'Dodatne slike',
        'status': 'Status',
        'draft': 'Osnutek',
        'publish': 'Objavi',
        'preview': 'Predogled',
        'unpublish': 'Odstrani objavo',
        'published': 'Objavljeno',
        'unpublished': 'Ni objavljeno',
        'imported': 'Uvoženo',
        'disabled': 'Onemogočeno',
        'disable': 'Onemogoči',
        'enable': 'Omogoči',
        'show_disabled': 'Prikaži onemogočene',
        'videos': 'Videoposnetki',
        'cta': 'CTA (Poziv k dejanju)',
        'primary_features': 'Primarne lastnosti',
        'main_features': 'Glavne lastnosti',
        'video_features': 'Video lastnosti',
        'secondary_features': 'Sekundarne lastnosti',
        'product_features': 'Lastnosti izdelka',
        'hero_banner': 'Hero sekcija',
        'tertiary_features': 'Terciarne lastnosti',
        'specifications': 'Specifikacije',
        'additional_specifications': 'Dodatne specifikacije',
        'attachment': 'Priloga',
        'attachments': 'Priloge',
        'disclaimer': 'Omejitev odgovornosti',
        'section_title': 'Naslov sekcije',
        'url': 'URL',
        'shipping': {
            'shipping': 'Dostava',
            'weight': 'Teža',
            'gross_weight': 'Bruto teža',
            'length': 'Dolžina',
            'width': 'Širina',
            'height': 'Višina'
        },
        'specification': {
            'type': 'Tip specifikacije',
            'add_new_specification_type': 'Dodaj nov tip specifikacije',
            'missing_specifications': 'Manjkajoče specifikacije',
            'from_categories': 'Iz izbranih kategorij',
            'from_categories_hint': 'Te specifikacije so dodane samodejno glede na izbrane kategorije izdelka.',
            'from_selected_template': 'Iz izbrane predloge',
            'from_selected_template_hint': 'Te specifikacije so dodane iz predloge, izbrane v spustnem seznamu zgoraj.',
            'template_already_from_category': 'Predloga "{names}" je že dodana samodejno glede na izbrane kategorije, zato bodo njene specifikacije prikazane dvakrat. Če je ne potrebujete posebej, jo v spustnem seznamu počistite.',
            'section_source': 'Predloga: {name}'
        },
        'section': {
            'basic_information': 'Osnovne informacije',
            'billing_information': 'Informacije za obračun',
            'media': 'Mediji',
            'features': 'Lastnosti',
            'specifications': 'Specifikacije',
            'attachments': 'Priloge',
            'disclaimer': 'Omejitev odgovornosti'
        },
        'add_new_value': 'Dodaj novo vrednost',
        'fill_from_another_locale': 'Izpolni iz drugega jezika',
        'fill_from_another_locale_info': 'Vaša trenutna vsebina bo izbrisana in izpolnjena z vsebino izbranega jezika.',
        'fill_content': 'Izpolni vsebino',
        'in_use': {
            'category': 'Izdelki, na katerih se uporablja kategorija',
            'product_brand': 'Izdelki, na katerih se uporablja blagovna znamka',
            'product_specification': 'Izdelki, na katerih se uporablja specifikacija izdelka',
            'sale_website': 'Izdelki, na katerih se uporablja spletna stran',
            'vat_group': 'Izdelki, na katerih se uporablja davčna stopnja'
        },
        'use_open_ai': 'Uporabi OpenAI za prevod',
        'export': 'Izvoz',
        'stocks': 'Zaloge',
        'prices': 'Cene',
        'product_not_synced': 'Izdelek ni sinkroniziran z ISelect-om',
        'warranty': 'Garancija',
        'warranty_unit': 'Enota garancije',
        'warranty_from_brand': 'blagovna znamka',
        'warranty_brand_hint': 'Če ostane prazno, velja garancija blagovne znamke: {warranty}',
        'warranty_units': {
            'month': 'Meseci',
            'year': 'Leta'
        },
        'warranty_unit_forms': {
            'month': {
                'one': 'mesec',
                'two': 'meseca',
                'few': 'meseci',
                'other': 'mesecev'
            },
            'year': {
                'one': 'leto',
                'two': 'leti',
                'few': 'leta',
                'other': 'let'
            }
        },
        'export_excel': 'Izvozi v Excel',
        'import_excel': 'Uvozi iz Excela',
        'import_excel_result': 'Rezultat uvoza iz Excela',
        'import_excel_created': 'Ustvarjeni izdelki',
        'import_excel_updated': 'Posodobljeni izdelki',
        'import_excel_specifications_updated': 'Posodobljene specifikacije',
        'import_excel_errors': 'Napake',
        'import_excel_row': 'Vrstica',
        'import_excel_success': 'Uvoz iz Excela je uspel',
        'import_excel_partial_success': 'Uvoz iz Excela je delno uspel, preverite napake'
    },
    'configuration': {
        'country_configuration': 'Konfiguracija države | Konfiguracije držav',
        'currency': 'Valuta',
        'petrol_categories_mapping': 'Preslikava Petrol kategorij',
        'petrol_category': 'Petrol kategorija',
        'petrol_category_code': 'Koda',
        'add_petrol_category': 'Dodaj Petrol kategorijo',
        'edit_petrol_category': 'Uredi Petrol kategorijo',
        'petrol_category_exists': 'Petrol kategorija s kodo {code} že obstaja',
        'petrol_category_missing_name': 'Manjka ime',
        'petrol_category_missing_name_error': 'Petrol kategorije brez kode ali imena: {codes}. Dopolnite jih in ponovno shranite.',
        'delete_petrol_category_in_use': 'Na Petrol kategorijo {code} {name} je preslikanih kategorij: {count}. Ko shranite, bodo izdelki iz njih v izvozu za Petrol brez klasifikacije. Ali jo res želite izbrisati?'
    },
    'additional_page': {
        'additional_page': 'Dodatna stran | Dodatne strani',
        'add': 'Dodaj dodatno stran',
        'edit': 'Uredi dodatno stran',
        'save': 'Shrani dodatno stran',
        'for': 'Dodatna stran za {name}',
        'add_in_other_language': 'Dodaj v drugem jeziku',
        'add_in_other_language_info': 'V izbranem jeziku bo dodana nova stran s skopirano vsebino te strani.',
        'exists_in_all_languages': 'Stran obstaja v vseh jezikih te prodajne strani',
        'new_page': 'Nova stran',
        'copied_from_page': 'Podatki so skopirani s strani "{name}". Izberite državo in shranjevanje bo ustvarilo novo stran.'
    },
    'sale_partner': {
        'sale_partner': 'Prodajni partner | Prodajni partnerji',
        'add': 'Dodaj prodajnega partnerja',
        'edit': 'Uredi prodajnega partnerja',
        'partner_key': 'Partnerski ključ',
        'product_export_type': 'Vrsta izvoza izdelka',
        'empty_price_list': 'Za izbranega partnerja je cenik prazen.',
        'prices': 'Cenik',
        'product_key': 'Šifra izdelka',
        'price_list_name': 'Ime cenika',
        'price_list_code': 'Šifra cenika',
        'validity': 'Veljavnost',
        'last_updated': 'Zadnja posodobitev'
    },
    'order': {
        'order': 'Naročilo | Naročila',
        'show_order': 'Prikaži naročilo',
        'order_number': 'Številka naročila',
        'copy_order_number': 'Kopiraj številko naročila',
        'order_date': 'Datum naročila',
        'total': 'Skupaj',
        'order_status': 'Stanje naročila',
        'payment_status': 'Stanje plačila',
        'order_success': 'Naročilo uspešno izvedeno',
        'order_failed': 'Naročilo ni bilo uspešno',
        'customer': 'Stranka',
        'created': 'Kreirano',
        'quantity': 'Količina',
        'subtotal': 'Vmesni seštevek',
        'phone': 'Telefon',
        'billing_address': 'Naslov za račun',
        'shipping_address': 'Naslov za dostavo',
        'same_as_billing_address': 'Enak naslovu za račun',
        'payment': 'Plačilo',
        'order_history': 'Zgodovina naročila',
        'items_in_order': 'Izdelki v naročilu',
        'transaction_id': 'ID transakcije',
        'message': 'Sporočilo',
        'status': {
            'pending': 'Naročeno',
            'processing': 'V obdelavi',
            'shipped': 'Odposlano',
            'ready_for_pickup': 'Pripravljeno na prevzem',
            'completed': 'Zaključeno',
            'not_picked_up': 'Zaključeno / neprevzeto',
            'cancelled': 'Preklicano'
        },
        'status_payment': {
            'pending': 'Na čakanju',
            'paid': 'Plačano',
            'failed': 'Neuspešno',
            'refunded': 'Vračilo'
        }
    },
    'inquiry': {
        'inquiry': 'Povpraševanje | Povpraševanja',
        'show_inquiry': 'Prikaži povpraševanje',
        'empty': 'Trenutno nimate aktivnih povpraševanj.',
        'terms_1': 'Z oddajo povpraševanja se strinjam s',
        'add_to_inquiry': 'Dodaj v povpraševanje',
        'proceed_to_offer': 'Nadaljuj na ponudbo',
        'preparation_of_offer': 'Priprava ponudbe',
        'success_add_to_inquiry': 'Izdelek je bil uspešno dodan v povpraševanje!',
        'go_to_inquiry_overview': 'Naprej na pregled povpraševanja',
        'send_inquiry': 'Pošlji povpraševanje',
        'address': 'Naslov',
        'inquiry_success': 'Povpraševanje uspešno poslano',
        'inquiry_failed': 'Povpraševanje ni bilo uspešno',
        'inquiry_number': 'Številka povpraševanja',
        'date_of_sent_inquiry': 'Datum poslanega povpraševanja',
        'inquiry_status': 'Status povpraševanja',
        'inquiry_history': 'Zgodovina povpraševanja',
        'items_in_inquiry': 'Izdelki v povpraševanju',
        'status': {
            'pending': 'Poslano',
            'processing': 'V obdelavi',
            'completed': 'Zaključeno',
            'cancelled': 'Preklicano'
        }
    },
    'theme': {
        'light': 'Svetla tema',
        'dark': 'Temna tema',
        'auto': 'Samodejno (po sistemu)'
    },
    'template': {
        'specification_template': 'Predloga specifikacij | Predloge specifikacij',
        'categories_changed_warning': 'Spremenili ste kategorije te predloge. Sprememba vpliva na obstoječe izdelke.',
        'categories_removed': 'Odstranjene kategorije: {names}',
        'categories_removed_effect': 'Izdelki v teh kategorijah bodo izgubili sekcije specifikacij iz te predloge, skupaj z že vnesenimi vrednostmi. Št. prizadetih izdelkov: {count}',
        'categories_added': 'Dodane kategorije: {names}',
        'categories_added_effect': 'Izdelki v teh kategorijah bodo samodejno dobili sekcije specifikacij iz te predloge, s praznimi vrednostmi. Št. prizadetih izdelkov: {count}',
        'categories_changed_hint': 'Sprememba se na posameznem izdelku uveljavi, ko ga naslednjič odprete v urejanju in shranite.'
    },
    'sync_status': {
        'sync_status': 'Status sinhronizacije | Statusi sinhronizacije',
        'running': 'V teku',
        'started_at': 'Začeto',
        'last_finished_at': 'Nazadnje končano',
        'refresh': 'Osveži',
        'force_sync_ishop_data': 'Sinhroniziraj podatke iz iShopa',
        'force_sync_sale_partner_price_lists': 'Sinhroniziraj cenike partnerjev',
        'sync_started': 'Sinhronizacija je zagnana in poteka v ozadju',
        'sync_already_running': 'Sinhronizacija že poteka',
        'names': {
            'sync_ishop_product_data': 'Sinhronizacija podatkov o izdelkih',
            'sync_ishop_product_stock': 'Sinhronizacija zalog',
            'sync_data_with_fts': 'Sinhronizacija iskalnika',
            'sync_ishop_sale_partner_price_list': 'Sinhronizacija cenikov partnerjev'
        }
    }
}
